<div class="d-flex flex-column justify-content-center align-items-center h-100" data-cy="loading-spinner">
  <omgui-spinner [size]="componentSize.extraSmall" class="align-self-center mb-4"></omgui-spinner>
  <h4 *ngIf="message">{{ message }}</h4>
</div>
